var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.804471 3.23707L11.9997 8.8347L23.1951 3.237C23.1107 1.76651 21.8915 0.600098 20.3998 0.600098H3.5998C2.10813 0.600098 0.888893 1.76655 0.804471 3.23707Z",
    fill: "#284254"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1998 6.36516L11.9997 11.9652L0.799805 6.36524V14.6001C0.799805 16.1465 2.05341 17.4001 3.5998 17.4001H20.3998C21.9462 17.4001 23.1998 16.1465 23.1998 14.6001V6.36516Z",
    fill: "#284254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f3a61b0b1a3f6a9e4c5056966ab5d840.svg";
export { ForwardRef as ReactComponent };